angular.module 'zc.commonApi'

.factory "PageTypeSampleUrl", ($resource, $q, pageTypeSampleUrlServiceRequestTransformer, PageType, Api) ->
  PageTypeSampleUrl = $resource Api.path("/api/projects/:projectId/page_type_sample_urls/:id"), { projectId: @projectId, id: @id },
    query:
      method: 'GET'
      isArray: false # Rails returns object instead of array
    create:
      method: 'POST'
    update:
      method: 'PATCH'
      transformRequest: pageTypeSampleUrlServiceRequestTransformer
    destroy:
      method: 'DELETE'
    options:
      method: 'GET'
      cache: true

  service =
    create: (params, obj) ->
      $q (resolve, reject) ->
        page_type_sample_url = new PageTypeSampleUrl(obj)
        page_type_sample_url.$save({projectId: params.projectId})
        .then (res) ->
          if res.success
            resolve res.page_type_sample_url
          else
            reject res

    update: (params, update) ->
      $q (resolve, reject) ->
        PageTypeSampleUrl.update(params, update).$promise.then (res) ->
          if res.success
            resolve res.page_type_sample_url
          else
            reject res

    all: (projectId) ->
      $q (resolve, reject) ->
        PageTypeSampleUrl.query {projectId: projectId}, (res) ->
          resolve res.page_type_sample_urls

    destroy: (pageType) ->
      $q (resolve, reject) ->
        PageTypeSampleUrl.destroy({ projectId: pageType.project_id, id: pageType.id}).$promise.then (res) ->
          if res.success
            resolve res
          else
            reject()
        , (err) ->
          reject err

    new: (options) ->
      DEFAULT_OPTIONS = {
        required_device: 'both'
        page_type: ''
        types: []
      }
      page_type_options = DEFAULT_OPTIONS
      page_type_options = angular.extend(page_type_options, options) if options
      new PageTypeSampleUrl(page_type_options)

    getPageTypeOptions: (projectId) ->
      PageType.getPageTypeOptions projectId

    getDevices: (projectId) ->
      PageType.getDevices projectId

  service

.factory 'pageTypeSampleUrlServiceRequestTransformer', () ->

  doTransform = (elem) ->
    elem = _.assignIn({}, elem)
    delete(elem["id"])
    delete(elem["isOk"])
    delete(elem["types"])
    return elem

  return (data) ->
    if data.page_type_sample_url
      data.page_type_sample_url = doTransform(data.page_type_sample_url)
    return angular.toJson(data)



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/page_type_sample_url_service.js.coffee